/* External dependencies */
import { Text } from 'atomize';
import React from 'react';

interface LabelTextProps {
  color: string;
  text: string;
}

export default function LabelText(props: LabelTextProps) {
  const { color, text } = props;

  return (
    <Text
      rounded="4px"
      tag="span"
      bg={color}
      p="10px 16px"
      textWeight="500"
      textAlign="center"
      textColor="white"
      textSize="12px"
      textTransform="uppercase"
      d="inline-block"
    >
      {text}
    </Text>
  );
}
